export const messages = {
  en: {
    editExamineStaff: {
      title: 'Edit Examine Staff',
      staffName: 'Staff Name',
      staffNamePlaceholder: 'Required, please enter staff name',
      projects: 'Examine Projects',
      staffPhoto: 'Staff Photo',
      post: 'Post',
      postPlaceholder: 'Required, please enter post',
      introduction: 'Introduction',
      staffNameRequired: 'Staff name is required',
      postRequired: 'Post is required',
      fetchProjectsError: 'Failed to get examine projects',
      fetchStaffError: 'Failed to get staff information'
    },
    uploadImage: {
      imageSizeLimit: 'Image size cannot exceed 2MB',
      uploadError: 'Image upload failed'
    }
  },
  zh: {
    editExamineStaff: {
      title: '修改考核员工',
      staffName: '员工名称',
      staffNamePlaceholder: '必填，请填写员工名称',
      projects: '考核项目',
      staffPhoto: '员工头像',
      post: '员工岗位',
      postPlaceholder: '必填，请填写员工岗位',
      introduction: '员工简介',
      staffNameRequired: '员工名称不能为空',
      postRequired: '员工岗位不能为空',
      fetchProjectsError: '获取考核项目失败',
      fetchStaffError: '获取员工信息失败'
    },
    uploadImage: {
      imageSizeLimit: '图片大小不能超过2MB',
      uploadError: '图片上传失败'
    }
  }
}